import { render, staticRenderFns } from "./PopupInstall.vue?vue&type=template&id=2288e5ca&scoped=true&"
import script from "./PopupInstall.vue?vue&type=script&lang=js&"
export * from "./PopupInstall.vue?vue&type=script&lang=js&"
import style0 from "./PopupInstall.vue?vue&type=style&index=0&id=2288e5ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288e5ca",
  null
  
)

export default component.exports